/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import "@fontsource/anton"
import "@fontsource/lily-script-one"
import "@fontsource/pacifico"
import "@fontsource/pragati-narrow/400.css"
import "@fontsource/pragati-narrow/700.css"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"
import "../styles/main.scss"
import Scroll from "./00Locomotive/locomotiveScroll"
import Header from "./03Organisms/header"


// import "./layout.css"
// import "./locomotive-scroll.css"

// This `location` prop will serve as a callback on route change
function Layout ({ song, children, location }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@truevined" />
        <meta property="og:title" content={""} />
        <meta name="twitter:title" content={""} />
        <meta property="og:image" content={""} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="500"/>
        <meta property="og:image:height" content="500"/>
        <meta property="og:image:alt" content={""} />
        <meta name="twitter:image" content={""} />
        <meta property="og:site_name" content={""} />
        <meta property="og:url" content="https://www.michellandtonye.com/" />      
        <meta property="og:locale" content="en_US" />
        <meta name="description" content={""} />
        <meta name="twitter:description" content={""} />
        <meta name="author" content={""} />
        
        <link rel="canonical" href="https://www.michellandtonye.com/" />

        {/* <link rel="stylesheet" as="font" href="https://fonts.googleapis.com/css2?family=Open+Sans&amp;family=Pragati+Narrow:wght@400;700&amp;family=Lily+Script+One&amp;family=Pacifico&amp;family=Anton&amp;family=Rancho&amp;family=Sura:wght@700&amp;display=swap" /> */}
        {/* <link rel="stylesheet" href="https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css"></link> */}

        <style type="text/css">{`
          html.has-scroll-smooth {
            overflow: hidden !important;
          }

          html.has-scroll-dragging {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
          .has-scroll-smooth body {
            overflow: hidden;
          }
          .has-scroll-smooth [data-scroll-container] {
            min-height: 100vh;
          }
          .c-scrollbar {
            position: absolute;
            right: 0;
            top: 0;
            width: 11px;
            height: 100vh;
            transform-origin: center right;
            transition: transform 0.3s, opacity 0.3s;
            opacity: 0;
            z-index: 99999;
          }
          .c-scrollbar:hover {
            transform: scaleX(1.45);
          }
          .c-scrollbar:hover,
          .has-scroll-dragging .c-scrollbar,
          .has-scroll-scrolling .c-scrollbar {
            opacity: 1;
          }
          .c-scrollbar_thumb {
            position: absolute;
            top: 0;
            right: 0;
            background-color: #bc8441;
            opacity: 0.5;
            width: 7px;
            border-radius: 10px;
            margin: 2px;
            cursor: -webkit-grab;
            cursor: grab;
          }
          .has-scroll-dragging .c-scrollbar_thumb {
            cursor: -webkit-grabbing;
            cursor: grabbing;
          }
        `}
        </style>
      
        <title>Michelle & Tonye | Wedding Day</title>
      </Helmet>

      <Header siteTitle={data.site.siteMetadata.title} />

      {/* Here we pass the callbacks to the component. Anything that impacts the innerHeight, for example: Font Loaded */}
      <Scroll callbacks={location} />
      {/* {!isMobile && <Cursor /> } */}
      {/* <Cursor2 /> */}


      <div id="container">
        <main>
          {children}
        </main>
      </div>

      <div id="awwwards" style={{position: "fixed", zIndex: 99999, transform: "translateY(-50%)", top: "50%",  right: 0}}><a href="https://www.awwwards.com/sites/michelle-tonye-wedding-day" target="_blank"><svg width="53.08" height="171.358"><path class="js-color-bg" fill="black" d="M0 0h53.08v171.358H0z"></path><g class="js-color-text" fill="white"><path d="M20.047 153.665v-1.9h3.888v-4.093h-3.888v-1.9h10.231v1.9h-4.59v4.093h4.59v1.9zM29.898 142.236c-.331.565-.784.997-1.359 1.294s-1.222.446-1.944.446c-.721 0-1.369-.149-1.943-.446a3.316 3.316 0 0 1-1.36-1.294c-.331-.564-.497-1.232-.497-2.002s.166-1.438.497-2.002a3.316 3.316 0 0 1 1.36-1.294c.574-.297 1.223-.445 1.943-.445.723 0 1.369.148 1.944.445a3.307 3.307 0 0 1 1.359 1.294c.331.564.497 1.232.497 2.002s-.166 1.438-.497 2.002m-1.703-3.347c-.435-.33-.967-.496-1.601-.496-.633 0-1.166.166-1.601.496-.433.332-.649.78-.649 1.346 0 .564.217 1.013.649 1.345.435.331.968.497 1.601.497.634 0 1.166-.166 1.601-.497.435-.332.649-.78.649-1.345.001-.566-.214-1.014-.649-1.346M22.911 134.852v-1.813h1.186a3.335 3.335 0 0 1-.951-1.009 2.423 2.423 0 0 1-.352-1.271c0-.682.19-1.229.57-1.645.381-.413.932-.621 1.652-.621h5.262v1.812h-4.721c-.419 0-.727.096-.921.285-.195.19-.292.447-.292.769 0 .302.115.58.35.833.234.254.577.458 1.03.613.454.156.993.234 1.616.234h2.938v1.813h-7.367zM29.898 125.136a3.314 3.314 0 0 1-1.359 1.294c-.575.297-1.222.445-1.944.445-.721 0-1.369-.148-1.943-.445a3.322 3.322 0 0 1-1.36-1.294c-.331-.565-.497-1.232-.497-2.002 0-.771.166-1.438.497-2.003a3.313 3.313 0 0 1 1.36-1.293c.574-.297 1.223-.446 1.943-.446.723 0 1.369.149 1.944.446s1.028.728 1.359 1.293.497 1.232.497 2.003c.001.769-.166 1.436-.497 2.002m-1.703-3.347c-.435-.331-.967-.497-1.601-.497-.633 0-1.166.166-1.601.497-.433.331-.649.778-.649 1.345 0 .564.217 1.013.649 1.344.435.332.968.498 1.601.498.634 0 1.166-.166 1.601-.498.435-.331.649-.779.649-1.344.001-.567-.214-1.014-.649-1.345M22.911 117.75v-1.812h1.199c-.419-.265-.742-.586-.972-.966s-.345-.784-.345-1.213c0-.272.05-.569.146-.892l1.682.336a1.429 1.429 0 0 0-.205.76c0 .576.261 1.048.783 1.418.521.37 1.342.557 2.461.557h2.617v1.812h-7.366zM29.812 111.252c-.391.511-.857.851-1.403 1.016l-.776-1.446c.381-.138.68-.329.893-.577.215-.249.321-.544.321-.885a1.2 1.2 0 0 0-.168-.658c-.112-.175-.294-.263-.548-.263-.225 0-.406.105-.548.313-.142.21-.291.534-.446.973-.019.068-.058.17-.117.307-.224.565-.506 1.004-.848 1.315-.34.313-.779.467-1.314.467-.381 0-.727-.102-1.039-.306a2.185 2.185 0 0 1-.744-.84 2.554 2.554 0 0 1-.279-1.207c0-.497.105-.949.314-1.359.211-.408.506-.725.886-.949l.993 1.082c-.43.292-.644.686-.644 1.184a.84.84 0 0 0 .154.504.471.471 0 0 0 .401.212c.176 0 .338-.103.49-.307.15-.205.334-.604.547-1.199.205-.564.474-1.001.805-1.308.332-.308.756-.46 1.271-.46.721 0 1.299.229 1.732.687s.65 1.057.65 1.797c.001.759-.194 1.396-.583 1.907M35.481 17.006l-4.782 14.969h-3.266l-2.584-9.682-2.584 9.682h-3.268l-4.782-14.969h3.713l2.673 10.276 2.525-10.276h3.445l2.524 10.276 2.674-10.276zM37.978 27.163c1.426 0 2.496 1.068 2.496 2.495 0 1.425-1.07 2.495-2.496 2.495-1.425 0-2.494-1.07-2.494-2.495-.001-1.427 1.069-2.495 2.494-2.495"></path></g></svg></a></div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
